import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PortalPermissions, usePortalMembership_GetPortalMembershipQuery } from 'queries';

import { NotificationSeverity, showAlert } from 'utils/notification-manager';

export default function useHasPortalPermission(permission: PortalPermissions) {
  const { portalId } = useParams<Record<string, string>>();

  const [hasPermission, setHasPermission] = useState(false);

  const { data: portalMembershipData } = usePortalMembership_GetPortalMembershipQuery({
    skip: !portalId,
    variables: { portalId },
    onError: (e) => {
      showAlert({
        message: 'Error getting portal membership: ' + e.message,
        severity: NotificationSeverity.ERROR,
      });
    },
  });

  useEffect(() => {
    setHasPermission(portalMembershipData?.data.permission === permission);
  }, [portalMembershipData, portalId, permission]);

  return hasPermission;
}
